<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <dr-text-field-spilka-ui-kit
      v-if="currentUIKit === 'spilkaUIKit'"
      :readonly="isReadonly"
      :disabled="isDisabled"
      :class="evaluateClasses(classes)"
      @input="onInput($event)"
      @click:append="onIconClick"
      @click:append-outer="onIconClick"
      @click:prepend="onIconClick"
      @click:prepend-inner="onIconClick"
      :value="getDataSourceField(model.Value)"
      :label="evaluateExpression(model.Caption)"
      :regular="isRegular"
      :solo="isSolo"
      :outlined="isOutlined"
      :filled="isFilled"
      :type="inputType"
      :prepend-icon="prependIcon"
      :prepend-inner-icon="prependInnerIcon"
      :append-icon="appendIcon"
      :append-outer-icon="appendOuterIcon"
    />
    <v-text-field
      v-else
      :readonly="isReadonly"
      :disabled="isDisabled"
      :class="evaluateClasses(classes)"
      @input="onInput($event)"
      @click:append="onIconClick"
      @click:append-outer="onIconClick"
      @click:prepend="onIconClick"
      @click:prepend-inner="onIconClick"
      :value="getDataSourceField(model.Value)"
      :label="evaluateExpression(model.Caption)"
      :regular="isRegular"
      :solo="isSolo"
      :outlined="isOutlined"
      :filled="isFilled"
      :type="inputType"
      :prepend-icon="prependIcon"
      :prepend-inner-icon="prependInnerIcon"
      :append-icon="appendIcon"
      :append-outer-icon="appendOuterIcon"
    ></v-text-field>
  </dr-wrapper>

  <dr-text-field-spilka-ui-kit
    v-else-if="currentUIKit === 'spilkaUIKit' && isVisible && !model.Mask"
    :tabindex="model.TabIndex"
    :readonly="readonly"
    :disabled="isDisabled"
    :type="inputType"
    :value="getDataSourceField(model.Value)"
    :class="evaluateClasses(classes)"
    :label="evaluateExpression(model.Caption)"
    :prepend-icon="prependIcon"
    :rules="_isRequiredField"
    :prepend-inner-icon="prependInnerIcon"
    :append-icon="appendIcon"
    :append-outer-icon="appendOuterIcon"
    :clearable="isClearable"
    @keyup="onKeyUp($event)"
    @change="invokeActionOnClick(model.GenerationOnChange, { value: $event })"
    @input="onInput($event)"
    @onIconClick="onIconClick"
  />
  <v-text-field
    v-else-if="isVisible && !model.Mask"
    ref="drTextFieldRef"
    :tabindex="model.TabIndex"
    :readonly="isReadonly"
    :disabled="isDisabled"
    :class="evaluateClasses(classes)"
    @input="onInput($event)"
    @click:append="onIconClick"
    @click:append-outer="onIconClick"
    @click:prepend="onIconClick"
    @click:prepend-inner="onIconClick"
    @keyup="onKeyUp($event)"
    @change="invokeActionOnClick(model.GenerationOnChange, { value: $event })"
    :value="getDataSourceField(model.Value)"
    :rules="_isRequiredField"
    :regular="isRegular"
    :solo="isSolo"
    :outlined="isOutlined"
    :filled="isFilled"
    :type="inputType"
    :prepend-icon="prependIcon"
    :prepend-inner-icon="prependInnerIcon"
    :append-icon="appendIcon"
    :append-outer-icon="appendOuterIcon"
    :clearable="isClearable"
  >
    <template v-if="label || model.Required" #label>
      <span v-if="label">{{ label }}</span>
      <span v-if="model.Required" class="dr-text-field-required-hint">*</span>
    </template>
  </v-text-field>
  <!-- Пакет vue-the-mask не поддерживает пустую маску, можно сделать свою дерективу на основне ke-the-mask -->
  <v-text-field
    v-else-if="isVisible && model.Mask"
    ref="drTextFieldRef"
    :tabindex="model.TabIndex"
    :readonly="isReadonly"
    :disabled="isDisabled"
    :class="evaluateClasses(classes)"
    @input="onInput($event)"
    @click:append="onIconClick"
    @click:append-outer="onIconClick"
    @click:prepend="onIconClick"
    @click:prepend-inner="onIconClick"
    @keyup="onKeyUp($event)"
    @change="invokeActionOnClick(model.GenerationOnChange, { value: $event })"
    :value="getDataSourceField(model.Value)"
    :label="evaluateExpression(model.Caption)"
    v-mask="model.Mask"
    :rules="_isRequiredField"
    :regular="isRegular"
    :solo="isSolo"
    :outlined="isOutlined"
    :filled="isFilled"
    :type="inputType"
    :prepend-icon="prependIcon"
    :prepend-inner-icon="prependInnerIcon"
    :append-icon="appendIcon"
    :append-outer-icon="appendOuterIcon"
    :clearable="isClearable"
  >
    <template v-if="label || model.Required" #label>
      <span v-if="label">{{ label }}</span>
      <span v-if="model.Required" class="dr-text-field-required-hint">*</span>
    </template>
  </v-text-field>
</template>

<script>
  import uk from '../../langs/drTextField/uk.json'
  import ru from '../../langs/drTextField/ru.json'
  import en from '../../langs/drTextField/en.json'

  import inputWidgetsWrapperMixin from '../../mixins/input-widgets-wrapper-mixin'
  import inputMixin from '../../mixins/input-mixin'
  import baseMixin from '../../mixins/base-mixin'
  import microflowMixin from '../../mixins/microflow-mixin'
  import actionMixin from '../../mixins/actions-mixin'
  import drTextFieldSpilkaUiKit from './dr-text-field-spilka-ui-kit.vue'
  import inputWidgetsValidateMixin from '../../mixins/input-widgets-validate-mixin'

  export default {
    components: { drTextFieldSpilkaUiKit },
    mixins: [inputMixin, baseMixin, microflowMixin, actionMixin, inputWidgetsWrapperMixin, inputWidgetsValidateMixin],
    data: () => ({
      showPassword: false,
      inputType: ''
    }),
    computed: {
      label() {
        return this.evaluateExpression(this.model.Caption)
      },
      _isRequiredField() {
        if (!this.model.Required) {
          return []
        }
        return [(val) => (val || '').length > 0 || `${this.model.Caption} - ${this.$t('drTestField.required')}`]
      },
      _modelType() {
        return this.model.Type || 'text'
      },
      prependIcon() {
        return this.model.PositionIcon === 'prepend-icon' ? this.model.IconName : undefined
      },
      prependInnerIcon() {
        return this.model.PositionIcon === 'prepend-inner-icon' ? this.model.IconName : undefined
      },
      appendIcon() {
        if (this.isPasswordType) {
          return this.showPassword ? 'mdi-eye-off' : 'mdi-eye'
        }
        return this.model.PositionIcon === 'append-icon' ? this.model.IconName : undefined
      },
      appendOuterIcon() {
        return this.model.PositionIcon === 'append-outer-icon' ? this.model.IconName : undefined
      },
      isClearable() {
        return this.model.IsClearable
      },
      isPasswordType() {
        if (!this._modelType) {
          return false
        }
        return this._modelType.toLocaleLowerCase() === 'password'
      }
    },
    methods: {
      onInput(val) {
        if (this.inputType === 'text' || this.isPasswordType) {
          this.setDataSourceField(this.model.Value, val)
          return
        }
        if (!isNaN(Number(val))) {
          this.setDataSourceField(this.model.Value, Number(val))
        }
      },
      onIconClick() {
        if (this.isPasswordType) {
          this.showPassword = !this.showPassword
          if (this.showPassword) {
            this.inputType = 'text'
          } else {
            this.inputType = this._modelType
          }
          return
        }

        this.invokeActionOnClick(this.model.IconActionOnclick)
      },
      onKeyUp(event) {
        this.invokeActionOnClick(this.model.KeyActionOnclick, { keyCode: event.code })
      }
    },

    mounted() {
      if (typeof this.getDataSourceField(this.model.Value) == 'number' && !this.isPasswordType) {
        this.inputType = 'number'
        return
      }

      this.inputType = this._modelType
    },

    i18n: {
      messages: {
        uk,
        en,
        ru
      }
    }
  }
</script>

<style>
  .dr-text-field-required-hint {
    font-size: 25px;
    color: red;
  }
</style>
